import { useState } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { ModalRoot, ModalTrigger } from '@mentimeter/ragnar-ui/modal';
import { HelpModal } from '@mentimeter/help-modal';
import type { HelpTab } from '@mentimeter/help-modal/help-tab';
import { trackUser } from '@api/tracking/client';
import { TrackingContext } from '@mentimeter/http-clients';

const helpModalTabs: HelpTab[] = [
  'Get started',
  'How to',
  'Help center',
  'Menti Academy',
  'Powerpoint',
];

export function HelpModalDataHandler({
  children,
}: { children: React.ReactNode }) {
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  const [activeHelpModalTab, setActiveHelpModalTab] =
    useState<HelpTab>('Get started');

  const handleHelpModalOpen = (open: boolean) => {
    setHelpModalOpen(open);
    if (open && activeHelpModalTab) {
      trackOpenedHelpTab({ tab: activeHelpModalTab });
    }
    if (!open)
      trackClosedHelpModal({
        tab: activeHelpModalTab,
      });
  };

  const handleActiveTabChange = (tab: HelpTab) => {
    setActiveHelpModalTab(tab);
    if (activeHelpModalTab !== tab) {
      trackOpenedHelpTab({ tab });
    }
  };

  return (
    <Box id="help-icon" justifyContent="center">
      <ModalRoot open={helpModalOpen} onOpenChange={handleHelpModalOpen}>
        <ModalTrigger>
          <Box id="help-thumbnail" width="100%">
            {children}
          </Box>
        </ModalTrigger>
        <HelpModal
          open={helpModalOpen}
          tabs={helpModalTabs}
          context={TrackingContext.MyPresentations}
          activeTab={activeHelpModalTab}
          onChangeActiveTab={handleActiveTabChange}
        />
      </ModalRoot>
    </Box>
  );
}

function trackOpenedHelpTab({ tab }: { tab: HelpTab }) {
  trackUser({
    event: 'Opened help tab',
    properties: {
      context: TrackingContext.MyPresentations,
      placement: 'Help tab',
      tab,
    },
  });
}

function trackClosedHelpModal({ tab }: { tab: HelpTab }) {
  trackUser({
    event: 'Closed help modal',
    properties: {
      context: TrackingContext.MyPresentations,
      placement: 'Help tab',
      tab,
    },
  });
}
